export default __webpack_public_path__ + "static/media/loginSvgXbank.bc3e09f1.svg";